import React from 'react';
import { Plus } from 'lucide-react';

const LibraryHeader = ({
  activeLibTab,
  setActiveLibTab,
  onCreateNew,
  isMobile,
  pausedCount = 0
}) => {
  if (isMobile) {
    return (
      <header className="flex-shrink-0 bg-white border-b border-notion-border px-5 pt-6 pb-0 z-20 flex flex-col gap-4 sticky top-0">
        <div className="flex items-center justify-between">
          <div>
            <div className="flex items-center gap-2 mb-1">
              <div className="w-5 h-5 bg-stone-800 rounded flex items-center justify-center text-white text-[10px] font-bold">K</div>
              <span className="font-semibold text-xs text-notion-text-light">Kaeros</span>
            </div>
            <h1 className="text-xl font-bold text-notion-text tracking-tight">Automation Library</h1>
          </div>
          <button
            onClick={onCreateNew}
            className="bg-black text-white px-3 py-1.5 rounded-lg text-xs font-medium shadow-sm flex items-center gap-1.5 mb-1 flex-shrink-0"
          >
            <Plus className="w-3.5 h-3.5" /> New
          </button>
        </div>

        <p className="text-xs text-notion-text-light truncate">Manage workflows, check health, and resume paused leads.</p>

        <div className="flex gap-6 overflow-x-auto mt-2">
          <button
            onClick={() => setActiveLibTab('active')}
            className={`pb-3 text-xs font-medium transition-colors whitespace-nowrap ${activeLibTab === 'active' ? 'border-b-2 border-notion-text text-notion-text' : 'border-b-2 border-transparent text-notion-text-light'}`}
          >
            Active Workflows
          </button>
          <button
            onClick={() => setActiveLibTab('paused')}
            className={`pb-3 text-xs font-medium transition-colors flex items-center gap-2 whitespace-nowrap ${activeLibTab === 'paused' ? 'border-b-2 border-notion-text text-notion-text' : 'border-b-2 border-transparent text-notion-text-light'}`}
          >
            Stopped / Paused
            {pausedCount > 0 && (
              <span className="bg-orange-50 text-orange-600 px-1.5 rounded text-[10px] border border-orange-100 font-bold">{pausedCount}</span>
            )}
          </button>
        </div>
      </header>
    );
  }

  return (
    <header className="flex-shrink-0 border-b border-notion-border px-8 pt-6 pb-0 bg-white z-20 flex flex-col gap-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-xl font-semibold text-notion-text tracking-tight">Automation Library</h1>
          <p className="text-xs text-notion-text-light mt-1">Manage workflows, check health, and resume paused leads.</p>
        </div>
        <button
          onClick={onCreateNew}
          className="bg-black text-white px-3 py-1.5 rounded text-xs font-medium hover:bg-stone-800 transition shadow-sm flex items-center gap-2"
        >
          <Plus className="w-3.5 h-3.5" /> Create New Workflow
        </button>
      </div>

      <div className="flex gap-8">
        <button
          onClick={() => setActiveLibTab('active')}
          className={`pb-3 text-xs font-medium transition-colors ${activeLibTab === 'active' ? 'border-b-2 border-notion-text text-notion-text' : 'border-b-2 border-transparent text-notion-text-light hover:text-notion-text'}`}
        >
          Active Workflows
        </button>
        <button
          onClick={() => setActiveLibTab('paused')}
          className={`pb-3 text-xs font-medium transition-colors flex items-center gap-2 ${activeLibTab === 'paused' ? 'border-b-2 border-notion-text text-notion-text' : 'border-b-2 border-transparent text-notion-text-light hover:text-notion-text'}`}
        >
          {/* TODO: Inject paused/stopped leads attention count from state/backend when available */}
          Stopped / Paused Leads
        </button>
      </div>
    </header>
  );
};

export default LibraryHeader;
